// @flow

import React from 'react';
// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';
import Button from 'components/atoms/Button';

// Types
import { gtmUserEventType } from 'types/gtm';

import './FlexPayPromo.scss';
const ns = 'flex-pay-promo';

type Props = {
  intl: IntlShape,
  flexPayUrl: string,
  gtmUserEvent: gtmUserEventType
};

class FlexPayPromo extends React.Component<Props> {
  getTitle = () => {
    const { intl } = this.props;
    return (
      <div>
        <div className={`${ns}__title`}>
          {intl.formatMessage({
            id: 'c8.flex.pay.title',
            defaultMessage:
              'Repair Loans' /* TODO: REMOVE ONCE YOU GET THE LOCALIZATIONS */
          })}
        </div>
      </div>
    );
  };

  getTextPromo = () => {
    const { intl } = this.props;
    return intl.formatMessage({
      id: 'c8.flex.pay.paragraph',
      defaultMessage:
        'We offer interest-free financing on services and repair work.' /* TODO: REMOVE ONCE YOU GET THE LOCALIZATIONS */
    });
  };

  render() {
    const { intl, flexPayUrl, gtmUserEvent } = this.props;

    return (
      <div className={`${ns}`}>
        {this.getTitle()}
        <div>
          <span>{this.getTextPromo()}</span>
          <Button
            buttonTheme="link"
            onClick={() => {
              window.open(flexPayUrl);
              gtmUserEvent(
                'Apply now flex pay',
                'Clicked',
                'FlexPay see details',
                'GTM_CURRENT_PAGE > Apply now Button'
              );
            }}
            className={'indexed'}
            tabIndex={0}
            aria-label={intl.formatMessage({
              id: 'c8.aria.dealership.financing.options',
              defaultMessage: 'Financing Options'
            })}
          >
            {intl.formatMessage({
              id: 'c8.flex.pay.apply.now',
              defaultMessage:
                'Apply now' /* TODO: REMOVE ONCE YOU GET THE LOCALIZATIONS */
            })}
          </Button>
        </div>
      </div>
    );
  }
}

export default FlexPayPromo;



// WEBPACK FOOTER //
// ./src/components/atoms/FlexPayPromo/FlexPayPromo.js